/**
 * Vídeo do conteúdo do post do blog e da coluna. O editor grava todo vídeo com
 * width/height 100% inline, e o CSS da página (`#slot-post-api video`) limita a altura
 * à da tela. Para o vídeo em pé ficar mais estreito, em vez de ganhar faixas vazias
 * nas laterais, o CSS precisa da proporção, que só se conhece com os metadados.
 */

/** HTMLMediaElement.HAVE_METADATA: a constante não existe fora do navegador. */
const TEM_METADADOS = 1;

type VideoDoPost = Pick<
  HTMLVideoElement,
  "videoWidth" | "videoHeight" | "readyState" | "style" | "addEventListener"
>;

/**
 * Grava em cada vídeo a variável `--proporcao-video` (largura/altura): na hora, se
 * os metadados já chegaram, ou quando chegarem. Sem dimensões, não grava, e o vídeo
 * fica na largura do texto.
 */
export function marcaProporcaoDosVideos(videos: Iterable<VideoDoPost>) {
  for (const video of videos) {
    const marca = () => {
      if (video.videoWidth && video.videoHeight)
        video.style.setProperty(
          "--proporcao-video",
          String(video.videoWidth / video.videoHeight)
        );
    };
    if (video.readyState >= TEM_METADADOS) marca();
    else video.addEventListener("loadedmetadata", marca, { once: true });
  }
}
